<template>
  <div>{{ type }}</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {object: {type: Object, required: true}},
    data(){
        return {

        }
    },
    computed: {
        ...mapGetters({
            categories: 'sanitaire/categorieAnalyses',
            typeAnalyses: 'sanitaire/typeAnalyses',
            typeRecherches: 'sanitaire/typeRecherches' 
        }),
        type(){
            let tr = this.typeRecherches.find(item => item.uid === this.object.typeRecherche)
            if(!tr) return '-'
            let c = this.categories.find(item => item.uid === tr.categorieAnalyse)
            if(!c) return '-'
            let t = this.typeAnalyses.find(item => item.uid === c.typeAnalyse)
            if(!t) return '-'
            return t.libelle
            
        }
    }
}
</script>

<style>

</style>